import { render, staticRenderFns } from "./CardiologyDrawer.vue?vue&type=template&id=aeda0b68&scoped=true&"
import script from "./CardiologyDrawer.vue?vue&type=script&lang=js&"
export * from "./CardiologyDrawer.vue?vue&type=script&lang=js&"
import style0 from "./CardiologyDrawer.vue?vue&type=style&index=0&id=aeda0b68&scoped=true&lang=css&"
import style1 from "./CardiologyDrawer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeda0b68",
  null
  
)

export default component.exports